import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { IntegrationSyncTime } from "app/pages/sales-intelligence/pages/management/components/ManagementSections/components/IntegrationSyncTime/IntegrationSyncTime";
import type { ListsDropdownButtonProps } from "app/pages/sales-intelligence/sub-modules/opportunities/components/top-section/ListsDropdown/types";
import { selectRecentlyViewedOpportunityList } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";

import PageTitle from "../../components/PageTitleButton/PageTitle";
import PageTitleButton from "../../components/PageTitleButton/PageTitleButton";
import { StyledAutoCreatedTag } from "../../components/PageTitleButton/styles";

import { StyledIntegrationSyncTimeWrapper } from "./styles";

type Props = ListsDropdownButtonProps;

const StaticListPageTitleButtonContainer = ({ list, onClick }: Props): ReactElement => {
    const recentlyViewedOpportunityList = useSelector(selectRecentlyViewedOpportunityList);

    const isRecentlyViewedList = list.id === recentlyViewedOpportunityList?.opportunityListId;
    const listTitle = isRecentlyViewedList ? translate("si.opportunity-list.auto-created.title") : list.name;

    return (
        <PageTitleButton onClick={onClick}>
            {isRecentlyViewedList ? (
                <PageTitle
                    list={list}
                    listTitle={listTitle}
                    listTag={<StyledAutoCreatedTag />}
                    listInfo={
                        <StyledIntegrationSyncTimeWrapper>
                            <IntegrationSyncTime
                                time={recentlyViewedOpportunityList.updated}
                                text={translate("si.opportunity-list.auto-created.last-update")}
                            />
                        </StyledIntegrationSyncTimeWrapper>
                    }
                />
            ) : (
                <PageTitle list={list} />
            )}
        </PageTitleButton>
    );
};

export default StaticListPageTitleButtonContainer;
